import Button from "@mui/material/Button";
import {_transl} from "../../store/localization/TranslMessasge";
import {CommonTranslation} from "../../pages/main/content/CommonTranslation";
import React from "react";
import {ButtonPropTypes} from "./ButtonPropTypes";

interface CloseButtonProps {
    onClick: (event?: any) => void,
    variant?: ButtonPropTypes.Variant,
    size?: ButtonPropTypes.Size;
}

export function CloseButton(props: CloseButtonProps) {

    const {onClick, variant, size} = props;

    return (
        <Button
            onClick={onClick}
            variant={variant ?? "contained"}
            size={size}
        >
            {_transl(CommonTranslation.CLOSE)}
        </Button>
    )
}

